import { render, staticRenderFns } from "./q8.vue?vue&type=template&id=2826c222"
import script from "./q8.vue?vue&type=script&lang=js"
export * from "./q8.vue?vue&type=script&lang=js"
import style0 from "./q8.vue?vue&type=style&index=0&id=2826c222&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports